export default {
  state: {
    iconSets: null,
    icons: null,
    chooseIcon: '',
    showPanel: false,
  },
  mutations: {
    updateIcons(state, data) {
      if (data) state.iconSets = data.iconSets
    },
    togglePanel(state) {
      state.showPanel = !state.showPanel
    },
    chooseIcon(state, icon) {
      state.chooseIcon = icon
    },
  },
  actions: {
    getIcons({ commit }) {
      this._vm.$http.get('/iconset').then((res) => {
        commit('updateIcons', res)
      })
    },
  },
  namespaced: true,
}
